import { render, staticRenderFns } from "./grid_list.vue?vue&type=template&id=74abfd36&"
import script from "./grid_list.vue?vue&type=script&lang=js&"
export * from "./grid_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74abfd36')) {
      api.createRecord('74abfd36', component.options)
    } else {
      api.reload('74abfd36', component.options)
    }
    module.hot.accept("./grid_list.vue?vue&type=template&id=74abfd36&", function () {
      api.rerender('74abfd36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/sys/list/grid_list.vue"
export default component.exports